import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
// These could be added to the containers index
import { hideBootSplashOnWelcome } from '../components/common/boot-splash';
import useAuth from '../hooks/utils/useAuth';
import { AuthenticatedRouter } from './authenticated-router';
import { useRouteTracking } from '../hooks/utils/useNavigation';
import { UnauthenticatedRouter } from './unauthenticated-router';

declare global {
  interface Window {
    branch: any;
  }
}

const Routes: React.FunctionComponent = (): JSX.Element | null => {
  const { pathname, search } = useLocation();
  const { user, authToken, authenticateWithSSOToken, isLoading } = useAuth();

  useRouteTracking();

  // this is to login sso users
  const ssoRedirect = new URLSearchParams(search).get('sso_redirect');
  const ssoAuthentication = useCallback(
    (ssoRedirect: string | null) => {
      if (ssoRedirect !== null && authenticateWithSSOToken.data === undefined && authenticateWithSSOToken.isIdle) {
        authenticateWithSSOToken.mutate({ token: ssoRedirect });
      }
    },
    [authenticateWithSSOToken],
  );

  useEffect(() => {
    ssoAuthentication(ssoRedirect);
  }, [ssoRedirect, ssoAuthentication]);

  // this sends you to the top of the window when you change pages
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    hideBootSplashOnWelcome(pathname);
  }, [pathname]);

  // A stored session waits for the member record. Logged-out pages, including welcome
  // after logout, render without waiting on Keycloak.
  if (authToken && isLoading && !user && !authenticateWithSSOToken.data) {
    return null;
  }

  return user ? <AuthenticatedRouter /> : <UnauthenticatedRouter />;
};

export default Routes;
